<template>
    <div v-show="show" class="auditDialog-container">
        <div v-if="config.type == 'notice'" class="auditDialog">
            <div class="main">
                <div class="title">{{config.title}}</div>
                <div class="content">
                    <p v-show="config.content1" v-html="config.content1"></p>
                    <p v-show="config.content2" v-html="config.content2"></p>
                </div>
            </div>
            <div class="btns">
                <p @click="btn1" v-show="config.btn1">{{ config.btn1 }}</p>
                <p @click="btn2" v-show="config.btn2">{{ config.btn2 }}</p>
            </div>
        </div>

        <div v-if="config.type == 'addMin'" class="minAuditDialog">
            <div class="title">{{title}}<p><span>审核流程中，至少需要X个不同的用户</span></p></div>
            <div v-click-outside="closeMinAudit" class="content">
                <p @click="isShowMinAudit = !isShowMinAudit">{{ minNumberList[minNumberIndex] }}</p><i @click="isShowMinAudit = !isShowMinAudit" :class="{on: isShowMinAudit}"></i>
                <div v-if="isShowMinAudit">
                    <div class="spare"></div>
                    <ul>
                        <li @click="minNumberIndex = index;isShowMinAudit = false;" v-for="(item, index) in minNumberList" :key="index"><p>{{ item }}</p><i :class="{on: index == minNumberIndex}"></i></li>
                    </ul>
                </div>
            </div>
            <div class="btns">
                <p @click="btn1" v-show="config.btn1">{{ config.btn1 }}</p>
                <p @click="btn2" v-show="config.btn2">{{ config.btn2 }}</p>
            </div>
        </div>

        <div v-if="config.type == 'reName'" class="inputAuditDialog">
            <div class="title">{{title}}</div>
            <div class="content"><p>当前流程名称：</p><input v-model="name" maxlength="50" type="text"></div>
            <div class="btns">
                <p @click="btn1" v-show="config.btn1">{{ config.btn1 }}</p>
                <p @click="btn2" v-show="config.btn2">{{ config.btn2 }}</p>
            </div>
        </div>

        <div v-if="isShow" class="auditDialog">
            <div class="main">
                <div class="title">温馨提示</div>
                <div class="content">
                    <p>该修改将同步至所有使用该配置的栏目</p>
                </div>
            </div>
            <div class="btns">
                <p @click="success">确定修改</p>
                <p @click="isShow = false">我再想想</p>
            </div>
        </div>
    </div>
</template>

<script>
import vClickOutside from "v-click-outside";
import common from '@common/common'
import { apis } from '@common/config'

export default {
    directives: {
        clickOutside: vClickOutside.directive
    },
    data() {
        return {
            isShow: false,
            name: '',
            isShowMinAudit: false,
            placeholder: '',
            show: false,
            config: {},
            callback: null,
            title: '参与审核最小人数',
            canEdit: true,
            maxLength: 100,
            num: 0,
            content: '',
            singleBtn: false,
            errTitle: '退回理由不能为空',
            minNumberList: [],
            minNumberIndex: 0
        }
    },
    methods: {
        closeMinAudit() {
            this.isShowMinAudit = false
        },
        success() {
            this.isShow = false;
            this.show = false;
            if(this.config.type == 'addMin'){
                this.callback(this.minNumberIndex)
            }else if(this.config.type == 'reName'){
                if(this.name){
                    this.show = false;
                    this.callback(this.name)
                }else{
                    this.$toast('当前流程名称不能为空')
                }
            }
        },
        btn1() {
            if(this.config.type == 'notice'){
                this.show = false;
                this.callback(true)
            }else if(this.config.type == 'reName'){
                // console.log(this.name)
                this.isShow = true
                
            }else if(this.config.type == 'addMin'){
                this.isShow = true
            }
        },
        btn2() {
            if(this.config.type == 'notice'){
                this.cancel()
            }else if(this.config.type == 'addMin'){
                this.cancel()
            }else if(this.config.type == 'reName'){
                this.cancel()
            }
        },
        open(config, callback) {
            if(config.type == 'addMin'){
                let info = {
                    template_id: config.id
                }

                common
                .myFetch(apis.admingetVerifyMinCount, {data: info})
                .then(r => {
                    if (r) {
                        // console.log(r)
                        if(r.data.valid_max_users_count == 0){
                            this.minNumberList.push(0)
                        }else{
                            for (let index = 1; index <= r.data.valid_max_users_count; index++) {
                                this.minNumberList.push(index)
                            }
                        }

                        // console.log(this.minNumberList)
                        if(r.data.current_min_users_count == 0){
                            this.minNumberIndex = r.data.current_min_users_count
                        }else{
                            this.minNumberIndex = r.data.current_min_users_count - 1
                        }
                    }
                });
            }
            this.title = config.title;
            this.name = config.name
            this.config = config;
            this.callback = callback;
            this.show = true;
        },
        confirm() {
            
        },
        cancel() {
            this.show = false;
            this.callback(false)
        },
        async close() {
            
        }
    }
}
</script>

<style lang="less">
    .auditDialog-container {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 1001;
        background-color: rgba(50, 59, 75, 0.3);
        backdrop-filter: blur(1.6px);

        .auditDialog {
            position: absolute;
            top: 50%;
            left: 50%;
            width: 432px;
            min-height: 170px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            margin-left: -216px;
            margin-top: -96px;
            background: #F9F9F9;
            box-shadow: 0px 4px 12px 0px rgba(0,0,0,0.15);
            border-radius: 4px;
            padding: 32px 32px 24px;
            box-sizing: border-box;

            .main {
                display: flex;
                flex-direction: column;
            }

            .title {
                font-size: 16px;
                line-height: 24px;
                color: #323B4B;
                margin-bottom: 12px;
                font-weight: bold;
            }

            .close {
                position: absolute;
                top: 20px;
                right: 30px;
                width: 21px;
                height: 21px;
                user-select: none;
                cursor: pointer;
            }

            .content {
                display: flex;
                flex-direction: column;

                p {
                    font-size: 14px;
                    line-height: 22px;
                    color: #666666;

                    span {
                        color: #41B48C;
                    }
                }
            }

            .btns {
                display: flex;
                align-items: center;
                justify-content: flex-end;

                p {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    padding: 0 16px;
                    height: 32px;
                    color: #FFF;
                    font-size: 14px;
                    font-weight: bold;
                    user-select: none;
                    cursor: pointer;
                    border-radius: 4px;

                    &:nth-of-type(1) {
                        background: #41B48C;
                    }

                    &:nth-of-type(2) {
                        background: #B9C3C3;
                        margin-left: 8px;
                    }
                }
            }
        }

        .minAuditDialog {
            position: absolute;
            top: 50%;
            left: 50%;
            width: 418px;
            height: 183px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            margin-left: -209px;
            margin-top: -91px;
            background: #F9F9F9;
            box-shadow: 0px 4px 12px 0px rgba(0,0,0,0.15);
            border-radius: 4px;
            padding: 30px 30px 24px;
            box-sizing: border-box;

            .main {
                display: flex;
                flex-direction: column;
            }

            .title {
                display: flex;
                align-items: center;
                font-size: 14px;
                line-height: 20px;
                color: #050F0F;
                font-weight: bold;

                p {
                    position: relative;
                    width: 16px;
                    height: 16px;
                    background: url('./assets/question.png') no-repeat;
                    background-position: center center;
                    background-size: 100% 100%;
                    margin-left: 4px;
                    user-select: none;
                    cursor: pointer;

                    &:hover {
                        background: url('./assets/questionOn.png') no-repeat;
                        background-position: center center;
                        background-size: 100% 100%;

                        span {
                            display: flex;
                        }
                    }

                    span {
                        position: absolute;
                        top: -48px;
                        left: -30px;
                        display: none;
                        width: max-content;
                        padding: 0 14px;
                        height: 32px;
                        background: #050F0F;
                        justify-content: center;
                        align-items: center;
                        font-size: 12px;
                        color: #FFFFFF;
                        box-sizing: border-box;
                        border-radius: 4px;
                    }
                }
            }

            .close {
                position: absolute;
                top: 20px;
                right: 30px;
                width: 21px;
                height: 21px;
                user-select: none;
                cursor: pointer;
            }

            .content {
                position: relative;
                display: flex;
                align-items: center;
                justify-content: space-between;
                width: 100%;
                height: 32px;
                background: rgba(185,195,195,0.2);
                border-radius: 2px;
                padding: 0 16px 0 20px;
                border: 1px solid transparent;
                box-sizing: border-box;
                margin-bottom: 30px;

                &.on {
                    border: 1px solid #41B48C;
                    box-sizing: border-box;
                }

                p {
                    flex: 1;
                    min-width: 0;
                    height: 100%;
                    font-size: 14px;
                    color: #323B4B;
                    line-height: 32px;
                    user-select: none;
                    cursor: pointer;
                }

                & > i {
                    display: block;
                    width: 12px;
                    height: 8px;
                    background: url('./assets/arrow.png') no-repeat;
                    background-position: center center;
                    background-size: 100% 100%;
                    transform: rotate(180deg);
                    user-select: none;
                    cursor: pointer;

                    &.on {
                        transform: rotate(0deg);
                    }
                }

                &>div {
                    position: absolute;
                    top: 32px;
                    left: 0;
                    z-index: 99;
                    width: 100%;

                    .spare {
                        width: 100%;
                        height: 8px;
                    }
                }

                ul {
                    
                    width: 100%;
                    background: #FFFFFF;
                    box-shadow: 4px 4px 10px 0px rgba(5,10,15,0.05);
                    border-radius: 4px;
                    overflow: hidden;

                    li {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        width: 100%;
                        height: 30px;
                        line-height: 30px;
                        text-align: center;
                        padding: 0 16px 0 20px;
                        box-sizing: border-box;
                        &:hover {
                            background: rgba(65,180,140,0.15);
                        }

                        p {
                            font-size: 12px;
                            line-height: 30px;
                            color: #050F0F;
                            text-align: left;
                        }

                        i.on {
                            width: 14px;
                            height: 11px;
                            background: url('./assets/gou.png') no-repeat;
                            background-position: center center;
                            background-size: 100% 100%;
                        }
                    }
                }
            }

            .btns {
                display: flex;
                align-items: center;
                justify-content: center;

                p {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 120px;
                    height: 32px;
                    color: #FFF;
                    font-size: 14px;
                    font-weight: bold;
                    user-select: none;
                    cursor: pointer;
                    border-radius: 4px;

                    &:nth-of-type(1) {
                        background: #41B48C;
                    }

                    &:nth-of-type(2) {
                        background: #B9C3C3;
                        margin-left: 20px;
                    }
                }
            }
        }

        .inputAuditDialog {
            position: absolute;
            top: 50%;
            left: 50%;
            width: 532px;
            height: 196px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            margin-left: -266px;
            margin-top: -98px;
            background: #F9F9F9;
            box-shadow: 0px 4px 12px 0px rgba(0,0,0,0.15);
            border-radius: 4px;
            padding: 20px 30px 24px;
            box-sizing: border-box;

            .main {
                display: flex;
                flex-direction: column;
            }

            .title {
                display: flex;
                align-items: center;
                font-size: 24px;
                line-height: 33px;
                color: #323B4B;
                font-weight: bold;

                p {
                    position: relative;
                    width: 16px;
                    height: 16px;
                    background: url('./assets/question.png') no-repeat;
                    background-position: center center;
                    background-size: 100% 100%;
                    margin-left: 4px;
                    user-select: none;
                    cursor: pointer;

                    &:hover {
                        background: url('./assets/questionOn.png') no-repeat;
                        background-position: center center;
                        background-size: 100% 100%;

                        span {
                            display: flex;
                        }
                    }

                    span {
                        position: absolute;
                        top: -48px;
                        left: -30px;
                        display: none;
                        width: max-content;
                        padding: 0 14px;
                        height: 32px;
                        background: #050F0F;
                        justify-content: center;
                        align-items: center;
                        font-size: 12px;
                        color: #FFFFFF;
                        box-sizing: border-box;
                        border-radius: 4px;
                    }
                }
            }

            .close {
                position: absolute;
                top: 20px;
                right: 30px;
                width: 21px;
                height: 21px;
                user-select: none;
                cursor: pointer;
            }

            .content {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 100%;

                p {
                    font-size: 14px;
                    line-height: 20px;
                    font-weight: bold;
                    color: #050F0F;
                    margin-right: 10px;
                }

                input {
                    flex: 1;
                    min-width: 0;
                    height: 32px;
                    background: rgba(185,195,195,0.2);
                    border-radius: 2px;
                    outline: none;
                    padding: 20px;
                    box-sizing: border-box;
                }
            }

            .btns {
                display: flex;
                align-items: center;
                justify-content: center;

                p {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 120px;
                    height: 32px;
                    color: #FFF;
                    font-size: 14px;
                    font-weight: bold;
                    user-select: none;
                    cursor: pointer;
                    border-radius: 4px;

                    &:nth-of-type(1) {
                        background: #41B48C;
                    }

                    &:nth-of-type(2) {
                        background: #B9C3C3;
                        margin-left: 20px;
                    }
                }
            }
        }
    }
</style>